exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-16aef69f] {\n  margin: 20px 0;\n  text-align: center;\n}\n.error span[data-v-16aef69f] {\n  display: inline-block;\n  padding: 15px;\n  color: #d94848;\n  background: #fff3f3;\n  border: 0.1rem solid #d94848;\n  border-radius: 4px;\n}", ""]);

// exports
